angular.module('bb.messaging', ['bb.users']);

require('./messaging_blast_listing.component');

require('./messaging.routes');
